export default {"src":"/_next/static/media/edit-pencil.f203baab.svg","height":16,"width":16};